module.exports = __webpack_public_path__ + "media/images/IconKO-daa1abc44bbb83e069d4970a5e6d73b1.png";